// Jarri administrarien ID-ak txatean kolore ezberdinez agertzeko.
export const AdminList = [1, 3];